import { ecbrRequest } from '../../request/ecbrRequest'

export const products = {
  getAll: async () => ecbrRequest.get('/products'),
  getById: async (id) => ecbrRequest.get(`/products/${id}`),
  create: async (product) => ecbrRequest.post('/products', product),
  update: async (id, product) => ecbrRequest.put(`/products/${id}`, product),
  auth: async () => ecbrRequest.get('/products/auth'),
  getImage: async (id) =>
    ecbrRequest.post(`/products/${id}/image`, { contentType: 'blob' }),
  setImage: async (idProduct, image) => {
    const formData = new FormData()
    formData.append('image', image)
    return ecbrRequest.patch(`/products/${idProduct}/image`, formData)
  }
}
